import Select, {components} from 'react-select'
import React, {useEffect, useMemo, useState} from 'react'
import {Modal, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import CreatableSelect from 'react-select/creatable'
import {OptionName} from '../../../../Contacts/AllContactsList/Constant/SelectOption'
import {useDispatch, useSelector} from 'react-redux'

import '../../../../Contacts/AllContactsList/Modal/Subscriber.scss'

import {
  BulkMsgDraftData,
  CreateUploadListForBulkMessage,
  CreateUploadListForBulkMessagePost,
} from '../../../BulkMessageSlice/BulkMessageSlice'
import {ContactOpenPopup} from '../../../../../../Components/PopupSlice/popupSlice'
import {usePutUploadContactsMutation} from '../../../../../../../services/cellcast.v2'
import ReviewContact from './ReviewContact'
import FieldPopupModel from '../../../../Contacts/AllContactsList/Modal/FieldPopupModel'
import {useLazyGetGroupQuery} from '../../../../../../../services/cellcast'
import {getDefaultRegion} from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  contactRegionRegex,
  validatePhoneNumberRegionWithMessage,
} from '../../../../../../Utils/_helpers'
import {toUpper} from 'lodash'

const enum ShowMode {
  Review,
  Mapping,
}

const UploadListMapping = ({
  show,
  handleClose,
  data,
  setMapped,
  mapped,
  finalData,
  setFinalData,

  setBulkMessageData,
  bulkMessageData,
}: any) => {
  const dispatch = useDispatch()
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const userRegion = useSelector(getDefaultRegion)

  const [showMode, setShowMode] = useState<ShowMode>(ShowMode.Mapping)
  const [reviewData, setReviewData] = useState<any>()
  const [sendLoading, setSendLoading] = useState(false)

  const [getGroup] = useLazyGetGroupQuery()

  const [error, setError] = useState('')
  const s: any[] = useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields)

  const [uploadContactsV2, resultUploadContacts] = usePutUploadContactsMutation()

  //////////////////////////////////////ALL NEW USESTATE////////////////////////
  const [selectedOption, setSeletedOption] = useState<any>([])
  const [newCreateBol, setNewCreateBol] = useState(true)
  const [totalSelectedOption, setTotalSelectedOption] = useState<any>([])
  const [disabledOption, setDisableOption] = useState<any>([])
  const [totalOption, setTotalOption] = useState<any>(OptionName)
  const dbOptions: any[] = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  ////////////////////////////////////New useEffect///////////////////////////////////
  ////First to set To

  const [fieldModel, setFieldModel] = useState(false)
  const [selectedData, setSelectedData] = useState<any>([])
  const [selectedField, setSelectedField] = useState<any>({
    inde: 0,
    name: '',
  })

  useEffect(() => {
    if (show) {
      let arrayOfOption: any = []
      let mappedDataAuto: any = []
      let selected: any = []
      data?.at(0)?.map((val: any, index: number) => {
        const sampleData = data?.length > 1 ? data[1] : []
        const checkNumberIndex = sampleData[index]

        const validateNumber = validatePhoneNumberRegionWithMessage({
          number: checkNumberIndex,
          region: userRegion,
          validateDuplicate: false,
          contacts: new Map(),
        })
        if (validateNumber.isValid) {
          const checkIsNumberIndex = sampleData.findIndex(
            (it: string) =>
              validatePhoneNumberRegionWithMessage({
                number: it,
                region: userRegion,
                validateDuplicate: false,
                contacts: new Map(),
              }).isValid
          )

          if (checkIsNumberIndex === index) {
            arrayOfOption?.push({value: 'mobile number', index: index})
            mappedDataAuto?.push({oldLabel: val, newLabel: 'mobile number'})
          }
        }
        let autoSelectedOption = totalOption?.find(
          (key: any) =>
            key?.value?.replace(/\s/g, '')?.toLowerCase() == val?.replace(/\s/g, '')?.toLowerCase()
        )
        if (autoSelectedOption) {
          arrayOfOption?.push({value: autoSelectedOption?.value, index: index})
          mappedDataAuto?.push({oldLabel: val, newLabel: autoSelectedOption.value})
          selected?.push({...autoSelectedOption, index})
        }
      })
      setDisableOption([...disabledOption, ...arrayOfOption])
      setMapped(mappedDataAuto)
      setSeletedOption(selected)
    }
  }, [show])
  useEffect(() => {
    if (dbOptions !== undefined) {
      let defaultOptions = OptionName?.map((val: any) => val.value)
      let newOptions = [...dbOptions, ...defaultOptions]
      let unique = newOptions
        .filter((item, i, ar) => ar.indexOf(item) === i)
        ?.map((val: any) => ({value: val, label: val}))

      unique?.length > 30 && setNewCreateBol(false)
      setTotalOption(unique)
      setTotalSelectedOption(dbOptions)
    }
  }, [show])

  //////////////////////////////////////NEW LOGIC FOR HANDLE SELECT//////////////////////
  const handleSelect = (e: any, index: any) => {
    ///////////////////////REMOVE SELECTED OPTION////////////////////////
    if (e == null) {
      let NameOfRemoveOption = disabledOption?.find((val: any) => val?.index === index)?.value
      ///First remove option from disabled option array////////
      let copyOfDisableOption = [...disabledOption]
      let indexOfDisableOption = disabledOption?.findIndex((val: any) => val?.index === index)

      if (indexOfDisableOption !== -1) {
        copyOfDisableOption.splice(indexOfDisableOption, 1)
        setDisableOption(copyOfDisableOption)
      }
      if (NameOfRemoveOption !== undefined) {
        let indexOfmapped = mapped?.findIndex((val: any) => val?.newLabel == NameOfRemoveOption)
        mapped.splice(indexOfmapped, 1)

        setMapped(mapped)
        if (
          [...dbOptions, 'mobile number']?.findIndex((val: any) => val == NameOfRemoveOption) == -1
        ) {
          totalSelectedOption.splice(totalSelectedOption?.indexOf(NameOfRemoveOption), 1)
          setTotalSelectedOption(totalSelectedOption)
        }
      }
    } else {
      /////event.value is there //////
      //////FIRST ---- DISABLE THE SELECTED OPTION ///////
      let copyDisableOption = [...disabledOption]
      let checkDisableOption = disabledOption?.findIndex((key: any) => key?.index === index)
      if (checkDisableOption !== -1) {
        copyDisableOption?.splice(checkDisableOption, 1, {value: e.value, index: index})
        setDisableOption(copyDisableOption)
      } else {
        setDisableOption([...disabledOption, {value: e.value, index: index}])
      }

      //////SECOND ----- ADD OPTION to totalSelected value if it not there
      if (!totalSelectedOption?.includes(e.value)) {
        setTotalSelectedOption([...totalSelectedOption, e.value])
      }
      if (!totalOption?.includes(e.value)) {
        setTotalOption([
          ...totalOption,
          {
            value: e.value,
            label: e.value,
          },
        ])
      }
      /////THIRD ------------ Map oldLable and NewLable and store it

      if (mapped.find((key: any) => key?.oldLabel === data[0][index])?.oldLabel == undefined) {
        if (e.value == 'mobile number') {
          const numberRegex = contactRegionRegex[toUpper(userRegion)]

          if (numberRegex.test(data[1][index]) || numberRegex.test(data[0][index])) {
            setMapped([...mapped, {oldLabel: data[0][index], newLabel: 'mobile number'}])
            setError('')
          } else {
            setError('Please select a valid Mobile Number field')
          }
        } else {
          setMapped([...mapped, {oldLabel: data[0][index], newLabel: e.value}])
        }
      } else {
        /////////remove and update disable option////////////////
        let indexOfDisableOption = disabledOption?.findIndex((val: any) => val?.index === index)
        disabledOption.splice(indexOfDisableOption, 1)
        setDisableOption([...disabledOption, {value: e.value, index: index}])
        /////////////////update oldLabel mapped data with newLabel data///////
        let indexOfMappedOldLabel = mapped.findIndex((key: any) => key?.oldLabel == data[0][index])
        mapped.splice(indexOfMappedOldLabel, 1)
        setMapped([...mapped, {oldLabel: data[0][index], newLabel: e.value}])
      }
      const tempData = Array.isArray(selectedData) ? [...selectedData] : []
      tempData[index] = {value: e.value, label: e.value}
      setSelectedData(tempData)
    }
  }

  const onCancel = () => {
    setTotalOption(OptionName)
    setMapped([])
    setDisableOption([])
    setFinalData({
      name: '',
      file: '',
      mergeLabels: '',
      tagIds: '',
    })
    handleClose()
    setDisableOption([])
  }

  const handleSubmit = () => {
    let data1 = new FormData()

    let ff: any = {
      name: finalData?.name,
      file: finalData?.file,
      mergeLabels: JSON.stringify(mapped),
      campaignUpload: true,
    }
    for (var key in ff) {
      data1.append(key, ff[key])
    }

    setSendLoading(true)
    if (groupid !== undefined) {
      dispatch(CreateUploadListForBulkMessagePost(data1)).then((res: any) => {
        setSendLoading(false)
        let id = res.payload.data.campaignTagId
        setBulkMessageData({
          ...bulkMessageData,
          to: {selectedType: 'uploadList', value: [`tag_${id}`]},
        })
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            scheduledAt: '',
            to: {selectedType: 'uploadList', value: [`tag_${id}`]},
          })
        )
        handleClose()
      })
    } else {
      dispatch(CreateUploadListForBulkMessage(data1)).then((res: any) => {
        setSendLoading(false)
        let id = res.payload.data.campaignTagId
        setBulkMessageData({
          ...bulkMessageData,
          to: {selectedType: 'uploadList', value: [`tag_${id}`]},
        })
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            scheduledAt: '',
            to: {selectedType: 'uploadList', value: [`tag_${id}`]},
          })
        )
        handleClose()
      })
    }

    setTotalOption(OptionName)
    setMapped([])
    dispatch(ContactOpenPopup())
    getGroup(null)
    setDisableOption([])
  }

  const handleReview = () => {
    let data = new FormData()

    let ff: any = {
      name: finalData?.name,
      unSubList: false,
      file: finalData?.file,
      mergeLabels: JSON.stringify(mapped),
      campaignUpload: true,
      validate: true,
    }
    for (var key in ff) {
      data.append(key, ff[key])
    }

    uploadContactsV2({
      data,
      id: groupid,
    }).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          setError(res?.data?.message)
        } else {
          setError('')
          setReviewData(res)
          setShowMode(ShowMode.Review)
        }
      } else if ('error' in res) {
        setError(`${res.error}`)
      }
    })
  }

  const MenuListComponent = (props: any) => {
    const {index, newCreateBol, ...rest} = props
    return (
      <components.MenuList {...rest}>
        {props.children}
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip id='button-tooltip'>Create new field</Tooltip>}
        >
          <div>
            {newCreateBol ? (
              <div
                className='select-create-button'
                onClick={() => {
                  setFieldModel(true)
                  setSelectedField({
                    index,
                  })
                }}
              >
                <i className='bi bi-plus-lg'></i>
                <p>Create new</p>
              </div>
            ) : null}
          </div>
        </OverlayTrigger>
      </components.MenuList>
    )
  }

  const FieldPopup = useMemo(
    () => (
      <FieldPopupModel
        show={fieldModel}
        handleClose={(name: any = {}) => {
          handleSelect(name, selectedField.index)
          setFieldModel(false)
        }}
      />
    ),
    [fieldModel]
  )

  useEffect(() => {
    let tempData: any[] = []
    tempData = data?.[0]?.map((val: any, index: number) => {
      /////Logic for auto select option
      return totalOption?.find((key: any) => {
        const validateNumber = validatePhoneNumberRegionWithMessage({
          number: data?.length > 1 ? data[1][index] : '',
          region: userRegion,
          validateDuplicate: false,
          contacts: new Map(),
        })

        if (validateNumber.isValid) {
          const checkIsNumberIndex = data[1].findIndex(
            (it: string) =>
              validatePhoneNumberRegionWithMessage({
                number: it,
                region: userRegion,
                validateDuplicate: false,
                contacts: new Map(),
              }).isValid
          )

          if (checkIsNumberIndex === index) {
            return key?.value?.replace(/\s/g, '')?.toLowerCase() === 'mobilenumber'
          }
          return false
        } else {
          let x =
            key?.value?.replace(/\s/g, '')?.toLowerCase() == val?.replace(/\s/g, '')?.toLowerCase()
          return x
        }
      })
    })
    setSelectedData(tempData)
  }, [data, totalOption])

  return (
    <>
      {FieldPopup}
      <Modal
        dialogClassName='modal-dialog-centered match_custom_data mw-650px'
        show={show}
        onHide={onCancel}
      >
        {showMode === ShowMode.Review ? (
          <ReviewContact
            error={error}
            report={reviewData}
            isLoading={sendLoading}
            handleCancel={onCancel}
            handleNext={() => handleSubmit()}
          />
        ) : (
          <>
            <div className='modal-header'>
              <h2>Match custom data</h2>
            </div>
            <div className='modal-body px-20'>
              {data?.[0]?.map((val: any, index: number) => {
                /////Logic for auto select option
                let autoSelectedOption = totalOption?.find((key: any) => {
                  const validateNumber = validatePhoneNumberRegionWithMessage({
                    number: data?.length > 1 ? data[1][index] : '',
                    region: userRegion,
                    validateDuplicate: false,
                    contacts: new Map(),
                  })

                  if (validateNumber.isValid) {
                    const checkIsNumberIndex = data[1].findIndex(
                      (it: string) =>
                        validatePhoneNumberRegionWithMessage({
                          number: it,
                          region: userRegion,
                          validateDuplicate: false,
                          contacts: new Map(),
                        }).isValid
                    )

                    if (checkIsNumberIndex === index) {
                      return key?.value?.replace(/\s/g, '')?.toLowerCase() === 'mobilenumber'
                    }
                    return false
                  } else {
                    let x =
                      key?.value?.replace(/\s/g, '')?.toLowerCase() ===
                      val?.replace(/\s/g, '')?.toLowerCase()
                    return x
                  }
                })

                return (
                  <div className='row justify-content-between mb-5 mt-10'>
                    <div className='col-5'>
                      {data?.map(
                        (val: any, index2: number) =>
                          index2 < 3 && (
                            <React.Fragment key={index2}>
                              {index2 == 0 ? (
                                <>
                                  {val?.map((key: any, index3: number) => (
                                    <React.Fragment key={index3}>
                                      {index3 == index && (
                                        <h3 className='fs-7' style={{color: '#232323'}}>
                                          {key}
                                        </h3>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </>
                              ) : (
                                <>
                                  {val?.map((key: any, index4: number) => (
                                    <React.Fragment key={index4}>
                                      {index4 == index && (
                                        <li
                                          className='list-unstyled fs-7'
                                          style={{color: '#A2A5B5'}}
                                        >
                                          {key}
                                        </li>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </>
                              )}
                            </React.Fragment>
                          )
                      )}
                    </div>
                    <div className='col-6'>
                      <label className='mb-2'>Match label to datafield</label>
                      <Select
                        classNamePrefix='createBox'
                        className='select_create react-tags-fieldBox selectbox-create-custom'
                        components={{
                          MenuList: (props) => (
                            <MenuListComponent
                              index={index}
                              newCreateBol={newCreateBol}
                              {...props}
                            />
                          ),
                        }}
                        isMulti={false}
                        onChange={(e: any) => {
                          handleSelect(e, index)
                        }}
                        isOptionDisabled={(option: any) => {
                          let d = disabledOption.map((val: any) => val.value)
                          return d?.includes(option.value)
                        }}
                        value={selectedData?.[index] ?? null}
                        // value={selectedData?.[index1] ?? null}
                        defaultValue={autoSelectedOption}
                        options={
                          newCreateBol
                            ? totalOption
                            : [
                                ...totalSelectedOption?.map((val: any) => ({
                                  value: val,
                                  label: val,
                                })),
                                {value: 'mobile number', label: 'Mobile Number'},
                              ]
                        }
                        isClearable
                      />
                    </div>
                  </div>
                )
              })}
            </div>
            <span className='text-danger mx-15'>{error}</span>
            <div className='modal-footer w-100'>
              <button
                onClick={onCancel}
                type='button'
                className='btn btn-light-primary'
                disabled={resultUploadContacts.isLoading}
              >
                Cancel
              </button>

              <button
                disabled={
                  !mapped?.map((val: any) => val?.newLabel)?.includes('mobile number') ||
                  resultUploadContacts.isLoading
                }
                onClick={() => {
                  handleReview()
                }}
                id='submit'
                type='button'
                className='btn btn-primary'
              >
                {resultUploadContacts.isLoading ? <Spinner size='sm' animation='grow' /> : 'Review'}
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  )
}

export default UploadListMapping
